import { render, staticRenderFns } from "./videohub.vue?vue&type=template&id=afd98af8&scoped=true"
import script from "./videohub.vue?vue&type=script&lang=js"
export * from "./videohub.vue?vue&type=script&lang=js"
import style0 from "./videohub.vue?vue&type=style&index=0&id=afd98af8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd98af8",
  null
  
)

export default component.exports